import { el } from './el';

/** Full-screen overlay panel that can be shown and hidden. */
export class Screen {
  readonly root: HTMLDivElement;
  readonly panel: HTMLDivElement;

  constructor(parent: HTMLElement, className: string) {
    this.root = el('div', `screen ${className}`);
    this.panel = el('div', 'panel');
    this.root.append(this.panel);
    parent.append(this.root);
  }

  show(): void {
    this.root.classList.add('show');
  }

  hide(): void {
    this.root.classList.remove('show');
  }

  button(label: string, onClick: () => void, variant = ''): HTMLButtonElement {
    const button = el('button', `btn ${variant}`, label);
    button.addEventListener('click', onClick);
    return button;
  }
}
